import { stringToColor } from '../../../utils/AvatarUtils';

export const WORKFLOW_OPERATOR_AGENT_NAME = 'Workflow Operator';

function parseHex(hex) {
  const normalized = hex.replace('#', '');
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
}

function toHex(r, g, b) {
  const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
  return `#${[r, g, b]
    .map((channel) => clamp(channel).toString(16).padStart(2, '0'))
    .join('')}`;
}

/** Lighten (amount > 0) or darken (amount < 0) a hex color toward white/black. */
export function shadeColor(hex, amount) {
  const { r, g, b } = parseHex(hex);
  if (amount < 0) {
    const factor = 1 + amount;
    return toHex(r * factor, g * factor, b * factor);
  }
  return toHex(
    r + (255 - r) * amount,
    g + (255 - g) * amount,
    b + (255 - b) * amount
  );
}

/** Pixel-art palette derived from the same base color as AgentAvatar. */
export function buildSpritePalette(baseColor) {
  return {
    '--px-outline': shadeColor(baseColor, -0.72),
    '--px-shadow': shadeColor(baseColor, -0.85),
    '--px-accent-deep': shadeColor(baseColor, -0.45),
    '--px-accent-dark': shadeColor(baseColor, -0.28),
    '--px-accent-mid': baseColor,
    '--px-highlight': shadeColor(baseColor, 0.35),
    '--px-glow': shadeColor(baseColor, 0.55),
    '--px-spark': shadeColor(baseColor, 0.72),
    '--px-screen': shadeColor(baseColor, 0.82),
    '--px-screen-shine': '#ffffff',
    '--px-eye': shadeColor(baseColor, -0.78),
    '--px-eye-shine': shadeColor(baseColor, -0.15),
  };
}

export function getWorkflowOperatorAvatarColor(name = WORKFLOW_OPERATOR_AGENT_NAME) {
  return stringToColor(name);
}

export function getWorkflowOperatorSpritePalette(name = WORKFLOW_OPERATOR_AGENT_NAME) {
  return buildSpritePalette(getWorkflowOperatorAvatarColor(name));
}

/** Theme-aware styles for the floating name tag under the sprite. */
export function getNameTagStyle(avatarColor, theme) {
  const isDark = theme.palette.mode === 'dark';

  if (isDark) {
    return {
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      border: `1px solid ${avatarColor}`,
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.45)',
      statusColor: theme.palette.text.secondary,
    };
  }

  return {
    background: avatarColor,
    color: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.22)',
    statusColor: 'rgba(255, 255, 255, 0.82)',
  };
}

